import React, { Component } from 'react';

class LicensesTable extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      licenses: [],
    };

    this.handleLicenseChange = this.handleLicenseChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { group, initialLicenses, annualLicenses } = nextProps;

    const licenses = [
      {
        id: 1,
        name: 'initialLicenses',
        product: 'PCMHGuide Initial Recognition',
        count: initialLicenses,
        cost: group.initial_cost,
      },
      {
        id: 2,
        name: 'annualLicenses',
        product: 'PCMHGuide Annual Reporting',
        count: annualLicenses,
        cost: group.annual_cost,
      },
    ];

    this.setState({ licenses });
  }

  handleLicenseChange(evt) {
    this.props.handleLicenseChange(evt);
  }

  render() {
    const { licenses } = this.state;
    const {
      initialLicenses,
      annualLicenses,
      initialTotal,
      annualTotal,
      isPayer,
    } = this.props;

    return (
      <div className="table-wrapper">
        <table className="table--licenses">
          <thead>
            <tr>
              <th>Product</th>
              <th>Subscription Count</th>
              <th>Cost per License</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {licenses.map(license => {
              return (
                <tr key={license.id}>
                  <td>{license.product}</td>
                  <td>
                    {isPayer ? (
                      <input
                        className="licenses-input"
                        type="number"
                        value={
                          license.name === 'initialLicenses'
                            ? initialLicenses
                            : annualLicenses
                        }
                        name={license.name}
                        onChange={this.handleLicenseChange}
                      />
                    ) : (
                      <div>
                        {license.name === 'initialLicenses'
                          ? initialLicenses
                          : annualLicenses}
                      </div>
                    )}
                  </td>
                  <td>
                    {license.name === 'initialLicenses'
                      ? `$${license.cost}/month`
                      : `$${license.cost}/year`}
                  </td>
                  <td>
                    $
                    {license.name === 'initialLicenses'
                      ? initialTotal
                      : annualTotal}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default LicensesTable;



// WEBPACK FOOTER //
// ./src/components/licenses/LicensesTable.js